module.exports = import("https://cdn.skypack.dev/shortid@2.2.16");;